import { MaterialModule } from './../material/material.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OficinaMainComponent } from './oficina-main/oficina-main.component';
import { OficinaMaintenanceComponent } from './oficina-maintenance/oficina-maintenance.component';

const MODULES = [
  CommonModule,
  MaterialModule
];

const COMPONENTS = [
  OficinaMainComponent,
  OficinaMaintenanceComponent
];

@NgModule({
  declarations: [
    COMPONENTS
  ],
  imports: [
    MODULES
  ]
})
export class OficinaModule { }
